import gql from 'graphql-tag';

import { query } from '@confluence/query-preloader-tools';

export function preloadOrgDefaultClassificationLevelIdQuery() {
	return query({
		// Note: we need to use the same name to ensure the preload caching behavior works correctly
		// eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming
		query: gql`
			query useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery {
				orgDefaultClassificationLevelId
			}
		`,
	});
}
